import React from 'react';
import { CheckCircle2 } from 'lucide-react'; // For the checkmark icons

const GrowingTrend = () => {
    // Data for the features, making it easy to manage
    const features = [
        {
            id: 1,
            text: (
                <>
                    <span className="font-semibold text-cyan-500">Simple to implement and launch in 5 minutes</span> on our platform: no training required
                </>
            ),
        },
        {
            id: 2,
            text: (
                <>
                    <span className="font-semibold text-cyan-500">Affordable platform cost</span> with fewer risks than hiring people
                </>
            ),
        },
        {
            id: 3,
            text: (
                <>
                    Reliability: the AI employee <span className="font-semibold text-cyan-500">doesn't get sick, go on vacation, or disappear unexpectedly</span>
                </>
            ),
        },
        {
            id: 4,
            text: (
                <>
                    Create <span className="font-semibold text-cyan-500">any unique AI employee</span> to replace a human role
                </>
            ),
        },
        {
            id: 5,
            text: (
                <>
                    <span className="font-semibold text-cyan-500">Timely response:</span> the AI employee responds instantly, 24/7
                </>
            ),
        },
        {
            id: 6,
            text: (
                <>
                    Transparency: <span className="font-semibold text-cyan-500">review any conversation</span> to improve quality of service
                </>
            ),
        },
    ];

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 sm:p-8 font-sans">
            <div className="bg-slate-800 p-8 sm:p-12 rounded-2xl w-full max-w-7xl relative overflow-hidden">
                {/* Decorative Top Right Icons/Images (Placeholder) */}
                <div className="absolute top-0 right-0 h-48 w-48 sm:h-64 sm:w-64 -mt-8 -mr-8 flex items-center justify-center opacity-70">
                    <div className="relative w-full h-full">
                        {/* Placeholder for Phone/Messages */}
                        <div className="absolute right-8 top-12 sm:right-12 sm:top-16 w-24 h-40 sm:w-32 sm:h-56 bg-slate-600 rounded-xl shadow-lg opacity-75 transform rotate-6"></div>
                        <div className="absolute right-0 top-0 w-28 h-48 sm:w-40 sm:h-64 bg-slate-700 rounded-xl shadow-lg opacity-90"></div>
                        {/* Placeholder for Envelopes */}
                        <div className="absolute left-0 bottom-0 w-24 h-16 sm:w-32 sm:h-20 bg-slate-500 rounded-lg shadow-md flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-slate-200" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                        </div>
                        <div className="absolute left-16 top-4 w-20 h-14 sm:w-28 sm:h-18 bg-slate-500 rounded-lg shadow-md flex items-center justify-center transform rotate-12">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-slate-200" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                        </div>
                    </div>
                </div>


                {/* --- Header --- */}
                <h1 className="text-4xl sm:text-5xl font-bold text-white mb-10 sm:mb-16 max-w-lg relative z-10">
                    A growing trend <br />for the next 10 years
                </h1>

                {/* --- Features Grid --- */}
                <div className="bg-white p-6 sm:p-10 rounded-2xl">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
                        {features.map((feature) => (
                            <div key={feature.id} className="flex items-start">
                                <CheckCircle2 className="h-6 w-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" />
                                <p className="text-slate-700 text-lg leading-relaxed">{feature.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GrowingTrend;

